
import { Gender } from 'app/redux/Profile/model'

function determineGender(firstName: string) {
    return fetch('https://api.genderize.io/?name=' + firstName)
    .then((x) => x.json())
    .then((x) => {
        if (x.gender === 'male') { return Gender.male }
        if (x.gender === 'female') { return Gender.female }
        return Gender.unidentified;
    });
}

export {
    determineGender
}



// WEBPACK FOOTER //
// ./src/app/services/GenderDetermination/index.ts